/**
 * Person attribute names the profile editors treat specially: the workspace
 * identifiers, the system-owned attributes, and the reserved names that carry a
 * "Reserved" badge.
 */
export const IdentifierKey = {
  Id: 'id',
  CioId: 'cio_id',
  Email: 'email',
  Phone: 'phone',
} as const;

export type IdentifierKey = (typeof IdentifierKey)[keyof typeof IdentifierKey];

export const CREATED_IN_CIO_AT = '_created_in_customerio_at';
export const TEST_USER = 'cio_test_user';
export const TEST_USER_DOUBLE_OPT_IN = 'cio_double_opt_in';
export const CIO_EMAIL_TRACKING_CONSENT = 'cio_email_tracking_consent';
/** A JSON attribute; its nested keys are listed as `cio_subscription_preferences.<path>`. */
export const CIO_SUBSCRIPTION_PREF_KEY = 'cio_subscription_preferences';
const TIMEZONE = 'timezone';
const TIMEZONE_VALID = 'timezone_valid';

/** Attributes the backend owns for a person; they can never be edited by hand. */
export const IMMUTABLE_CUSTOMER_ATTRIBUTES: readonly string[] = [TEST_USER, TEST_USER_DOUBLE_OPT_IN];

/**
 * Reserved names: shown with a "Reserved" badge, and ordered ahead of custom
 * attributes in an attribute list.
 */
export const RESTRICTED_ATTRIBUTES: readonly string[] = [
  IdentifierKey.Id,
  IdentifierKey.Email,
  CREATED_IN_CIO_AT,
  'anonymous_id',
  'created_at',
  'email_sha256',
  'mobile_ad_id',
  'mobile_ad_id_sha256',
  'unsubscribed',
  TEST_USER,
  TEST_USER_DOUBLE_OPT_IN,
  CIO_EMAIL_TRACKING_CONSENT,
  TIMEZONE,
  TIMEZONE_VALID,
];

/** Attribute names that cannot be renamed or removed from a profile. */
export const PERMANENT_ATTRIBUTES: readonly string[] = [
  IdentifierKey.CioId,
  IdentifierKey.Id,
  IdentifierKey.Email,
  'created_at',
  CREATED_IN_CIO_AT,
  TIMEZONE,
  TIMEZONE_VALID,
];
